<main class="min-h-screen flex flex-col">
  <app-head
    [brand]="legalEntity.vehicleBrand"
    [userName]="userName"
  />

  <div class="flex-1">
    <router-outlet />
  </div>

  <app-footer
    [legalEntity]="legalEntity"
    [consentVersion]="consentVersion"
  />
</main>
